var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03125 5.5625C4.77237 5.5625 4.5625 5.77237 4.5625 6.03125V18.9688C4.5625 19.2276 4.77237 19.4375 5.03125 19.4375H17.9688C18.2276 19.4375 18.4375 19.2276 18.4375 18.9688V16.3961C18.4375 16.0854 18.6893 15.8336 19 15.8336C19.3107 15.8336 19.5625 16.0854 19.5625 16.3961V18.9688C19.5625 19.849 18.849 20.5625 17.9688 20.5625H5.03125C4.15105 20.5625 3.4375 19.849 3.4375 18.9688V6.03125C3.4375 5.15105 4.15105 4.4375 5.03125 4.4375H7.6039C7.91456 4.4375 8.1664 4.68934 8.1664 5C8.1664 5.31066 7.91456 5.5625 7.6039 5.5625H5.03125Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8125 5.19482C11.8125 4.88416 12.0643 4.63232 12.375 4.63232H18.2879C18.8834 4.63232 19.3661 5.11502 19.3661 5.71045V11.8377C19.3661 12.1483 19.1142 12.4002 18.8036 12.4002C18.4929 12.4002 18.2411 12.1483 18.2411 11.8377V5.75732H12.375C12.0643 5.75732 11.8125 5.50548 11.8125 5.19482Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6656 5.33271C18.8853 5.55238 18.8853 5.90854 18.6656 6.12821L12.5789 12.2151C12.3592 12.4348 12.0031 12.4348 11.7834 12.2151C11.5637 11.9955 11.5637 11.6393 11.7834 11.4196L17.8701 5.33273C18.0898 5.11305 18.4459 5.11305 18.6656 5.33271Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.727c481634b337ae2b07a41715d8d3ad.svg";
export { ForwardRef as ReactComponent };